import * as React from 'react';
import { connect } from 'react-redux';
import { scrollToScrollClass, setDriverType, updateClaimPartyReducer, validateClaimParties, setFnolReducerPayload, setFollowUpSteps } from '../../../../actions/claimSubmitActions';
import ClaimsThirdPartyComponent from '../../../FNOL/ThirdParty/ClaimsThirdPartyComponent';
import { IThirdPartyConfig } from '../../../../interfaces/ThirdParty/ThirdPartyInterface';
import { THIRDPARTY_TYPE_OTHER, THIRDPARTY_TYPE_WITNESS, THIRDPARTY_TYPE_PEDESTRIAN, THIRDPARTY_TYPE_PASSENGER, SET_STEPS_FOLLOW_UP_POTHOLE, SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE, SET_STEPS_FOLLOW_UP_PEDESTRIAN, SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY, ThirdPartyConfigurations } from "../../../../constants/constants";
import { navigateTo } from '../../../../actions/navigationActions';
import { FNOL_SUBMIT_CLAIM } from '../../../../routes/routes';


class ThirdPartyPage extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            reRender: true,
            hasDriverType: undefined,
            submitted: false,
            errorList: [],
        };

        this.handleAdd = this.handleAdd.bind(this);
        this.toggleSubmitted = this.toggleSubmitted.bind(this);
        this.resubmit = this.resubmit.bind(this);
        this.goFollowUp = this.goFollowUp.bind(this);
        this.goPothole = this.goPothole.bind(this);
        this.goPedestrian = this.goPedestrian.bind(this);
        this.goFollowUpStationary = this.goFollowUpStationary.bind(this);
    }

    async handleAdd(partyType) {
        await this.setState({ reRender: false })
        await this.props.dispatchAction(updateClaimPartyReducer(partyType, 'add'));
        await this.props.dispatchAction(setDriverType(partyType));
        await this.setState({ reRender: true })
        await this.setState({ hasDriverType: true })
    }

    async toggleSubmitted() {
        await this.setState({ submitted: !this.state.submitted })
        let thirdPartyConfigurations = ThirdPartyConfigurations;
        let errorList = await this.props.dispatchAction(validateClaimParties(thirdPartyConfigurations.find(x => x.thirdPartyConfigType == this.props.claimSubmit.driverType) as IThirdPartyConfig));

        if (errorList && errorList.length > 0 && this.state.submitted) {
            await this.setState({ reRender: false })
            await this.setState({ errorList: errorList, reRender: true })
            scrollToScrollClass();
        }
    }

    async resubmit() {
        await this.setState({ submitted: true })
        let thirdPartyConfigurations = ThirdPartyConfigurations;
        let errorList = await this.props.dispatchAction(validateClaimParties(thirdPartyConfigurations.find(x => x.thirdPartyConfigType == this.props.claimSubmit.driverType) as IThirdPartyConfig));

        if (errorList && errorList.length > 0) {
            await this.setState({ reRender: false })
            await this.setState({ errorList: errorList, reRender: true })
            scrollToScrollClass();
        }
    }

    async goFollowUp() {
        let steps = {
            "fnolStep": 1,
            "fnolSubStep": 4,
            "nextFnolSubStep": 1,
            "nextFnolStep": 1,
            "claimType": "CLAIM_TYPE_NORMAL",
            "selectedClaimStep": {
                "maxSubSteps": 1,
                "stepLabel": 1,
                "step": 1,
                "subStep": 1,
                "maxMobileSubSteps": 1,
                "title": "Incident Info",
                "subTitle": "We need a few more details"
            },
            "fnolStepConfiguration": {
                "steps": [
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 1,
                        "step": 1,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Incident info",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 2,
                        "step": 2,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Road surface",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 3,
                        "step": 3,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Other party/parties",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 4,
                        "step": 4,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Passengers/witnesses",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 5,
                        "step": 5,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Injured party/parties",
                        "subTitle": "We need a few more details"
                    }
                ]
            },
            "isCar": true,
            "hasDamageSelected": true,
            "claimDamagePhotoTypes": [
                {
                    "id": 4,
                    "location": "front",
                    "description": "Front",
                    "imageName": "car-front",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 5,
                    "location": "front",
                    "description": "Windscreen",
                    "imageName": "car-windscreen",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 6,
                    "location": "front",
                    "description": "Bonnet",
                    "imageName": "car-bonnet",
                    "photoData": "",
                    "isSelected": true
                },
                {
                    "id": 7,
                    "location": "frontLeft",
                    "description": "Front left",
                    "imageName": "car-frontleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 8,
                    "location": "frontLeft",
                    "description": "Front left door",
                    "imageName": "car-frontleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 9,
                    "location": "frontLeft",
                    "description": "Front left window",
                    "imageName": "car-frontleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 10,
                    "location": "frontLeft",
                    "description": "Front left tyre",
                    "imageName": "car-frontlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 11,
                    "location": "frontRight",
                    "description": "Front right",
                    "imageName": "car-frontright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 12,
                    "location": "frontRight",
                    "description": "Front right door",
                    "imageName": "car-frontrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 13,
                    "location": "frontRight",
                    "description": "Front right window",
                    "imageName": "car-frontrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 14,
                    "location": "frontRight",
                    "description": "Front right tyre",
                    "imageName": "car-frontrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 15,
                    "location": "backLeft",
                    "description": "Back left",
                    "imageName": "car-backleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 16,
                    "location": "backLeft",
                    "description": "Back left door",
                    "imageName": "car-backleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 17,
                    "location": "backLeft",
                    "description": "Back left window",
                    "imageName": "car-backleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 18,
                    "location": "backLeft",
                    "description": "Back left tyre",
                    "imageName": "car-backlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 19,
                    "location": "backRight",
                    "description": "Back right",
                    "imageName": "car-backright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 20,
                    "location": "backRight",
                    "description": "Back right door",
                    "imageName": "car-backrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 21,
                    "location": "backRight",
                    "description": "Back right window",
                    "imageName": "car-backrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 22,
                    "location": "backRight",
                    "description": "Back right tyre",
                    "imageName": "car-backrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 23,
                    "location": "back",
                    "description": "Back",
                    "imageName": "car-back",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 24,
                    "location": "back",
                    "description": "Back window",
                    "imageName": "car-backwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 25,
                    "location": "back",
                    "description": "Boot",
                    "imageName": "car-boot",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 65,
                    "location": "special",
                    "description": "Undercarriage damage",
                    "imageName": "car-undercarriagedamage",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 66,
                    "location": "special",
                    "description": "Interior",
                    "imageName": "car-interior",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 67,
                    "location": "special",
                    "description": "Airbag popped",
                    "imageName": "car-airbagpopped",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 68,
                    "location": "special",
                    "description": "Sunroof",
                    "imageName": "car-sunroof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 69,
                    "location": "special",
                    "description": "Roof",
                    "imageName": "car-roof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 70,
                    "location": "special",
                    "description": "Locks",
                    "imageName": "car-locks",
                    "photoData": "",
                    "isSelected": false
                }
            ],
            "selectedDamagePhotoTypes": [],
            "damageListCar": {
                "damageFront": true,
                "damageFrontLeft": false,
                "damageFrontRight": false,
                "damageBackLeft": false,
                "damageBackRight": false,
                "damageBack": false,
                "damageExtras": false
            },
            "selectedRiskItem": {
                "isMainline": true,
                "image": "car",
                "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                "excess": "4500.00",
                "productId": "4c0cb071-42dd-4060-99ff-9f0214113451",
                "productName": "Car",
                "product": 1,
                "riskItems": [
                    {
                        "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                        "riskItemId": "3dc7fad9-dd76-4df8-816d-adc100b35dd8",
                        "description": "2020 BMW 220D M SPORT A/T(F22)",
                        "premium": "3303.71",
                        "excess": "4500.00",
                        "excessDescription": null,
                        "insuredForValue": null,
                        "regularDriver": {
                            "firstName": "Styling",
                            "surname": "User",
                            "gender": "F",
                            "idNumber": "6909211760083",
                            "dateOfBirth": "21 September 1969",
                            "licenseCode": "Code C - Truck > 16,000kg",
                            "licenseIssueDate": "June 2006"
                        },
                        "vehicleDetails": {
                            "registrationNumber": "NOTPROVIDED",
                            "vinNumber": "Not provided",
                            "engineNumber": "Not provided",
                            "year": 2020,
                            "colour": "Not provided",
                            "vehicleImported": "No",
                            "vehicleUse": "Not provided",
                            "vehicleMake": "BMW",
                            "vehicleModel": "2 SERIES",
                            "mmCode": null,
                            "vehicleModified": null,
                            "vehicleRegisteredLocally": null,
                            "approximateKilometers": 0,
                            "fullServiceHistory": null,
                            "vehicleSeries": "220D M SPORT A/T(F22)"
                        },
                        "chilliDetails": null,
                        "watercraftDetails": null,
                        "warrantyDetails": null,
                        "portablePossessions": [],
                        "blingBrandNewCovers": [],
                        "blingLikeNewCovers": [],
                        "blingScreenFixCovers": [],
                        "address": {
                            "oneLineAddress": null,
                            "twoLineAddress": null,
                            "fullAddress": "478 Pretoria Street, SILVERTON, 0184",
                            "dayAddress": ""
                        },
                        "inspectionRequired": true,
                        "insuranceDuration": "6 years",
                        "numberOfClaims": 0,
                        "lastStolenClaim": "Not Provided",
                        "lastAccidentClaim": "13 - 24 months (1 - 2 years)",
                        "existingWarranty": null,
                        "personalAccidentCoverValue": null,
                        "hasError": false,
                        "coverStartDate": "14-10-2021"
                    }
                ],
                "accessories": [
                    {
                        "id": 29,
                        "replacementValue": 2100,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "We'll replace your windscreen film as long as it's insured with the king.",
                        "title": "Smash and grab",
                        "subtitle": "2100.00",
                        "icon": "icons-vap-icons-smash-and-grab-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 28,
                        "replacementValue": 2300,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Sunroof",
                        "subtitle": "2300.00",
                        "icon": "icons-vap-icons-sunroof-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 2,
                        "replacementValue": 2000,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "You chose them, we'll cover them. Tell us how much they're worth and we'll handle the rest!",
                        "title": "Mags and rims",
                        "subtitle": "2000.00",
                        "icon": "icons-vap-icons-mags-and-rims-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 26,
                        "replacementValue": 2200,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Leather seats",
                        "subtitle": "2200.00",
                        "icon": "icons-vap-icons-leather-seats-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    }
                ],
                "vaps": [
                    {
                        "id": "0ec1dcaa-a6f7-4c86-905a-00fd55022569",
                        "vapTypeId": 1,
                        "premium": 75,
                        "isActive": true,
                        "description": "Covers minor repairs to the exterior of your car ... Like those mysterious dings that 'just happen'.",
                        "title": "Scratch and dent",
                        "icon": "icons-vap-icons-scratch-and-dent-active",
                        "reasonRequired": true,
                        "premiumText": "75.00",
                        "enabled": true
                    },
                    {
                        "id": "916e328e-ad96-4d6c-a3e8-42b095bcb805",
                        "vapTypeId": 2,
                        "premium": 39,
                        "isActive": true,
                        "description": "From rocks, to glass to other road hazards… We’ll make sure your tyres and rims keep going round and round, no matter the damage",
                        "title": "Tyre and Rim",
                        "icon": "icons-vap-icons-tyre-and-rim-active",
                        "reasonRequired": true,
                        "premiumText": "39.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113460",
                        "vapTypeId": 1,
                        "premium": 19.5,
                        "isActive": true,
                        "description": "Offers you (and your car) a safe ride home, when driving yourself just isn't a good idea.",
                        "title": "Kings Cab",
                        "icon": "icons-vap-icons-kings-cab-active",
                        "reasonRequired": true,
                        "premiumText": "19.50",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113461",
                        "vapTypeId": 2,
                        "premium": 129,
                        "isActive": true,
                        "description": "This ensures that you'll have rental wheels for 30 days when your own are being repaired by 1 of our suppliers following a successful claim.",
                        "title": "Car Hire",
                        "icon": "icons-vap-icons-car-hire-active",
                        "reasonRequired": true,
                        "premiumText": "129.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113467",
                        "vapTypeId": 3,
                        "premium": 116.29,
                        "isActive": true,
                        "description": "Covers the difference between what your car/motorbike is worth at the time of it being stolen or written off, and what you still owe on it.",
                        "title": "Credit Shortfall",
                        "icon": "icons-vap-icons-credit-shortfall-active",
                        "reasonRequired": true,
                        "premiumText": "116.29",
                        "enabled": true
                    }
                ],
                "accesoriesTotal": 8600,
                "policyCoverId": "54ced8d9-2135-41ad-a56c-adc100b3f7af"
            },
            "incidentType": {
                "id": 1,
                "description": "Collision"
            },
            "mbFront": [
                "Front fairing",
                "Front mudguard",
                "Windshield",
                "Headlight",
                "Front tyre",
                "Handlebars",
                "Front brake"
            ],
            "mbFrontLeft": [
                "Left shock",
                "Left indicator",
                "Left mirror",
                "Left fairing",
                "Clutch lever",
                "Left front footrest",
                "Gear lever",
                "Front left brake"
            ],
            "mbFrontRight": [
                "Right shock",
                "Right indicator",
                "Right mirror",
                "Right fairing",
                "Front brake lever",
                "Right front footrest",
                "Right front brake"
            ],
            "mbBackLeft": [
                "Left side engine",
                "Left rear footrest",
                "Left side exhaust",
                "Left side frame",
                "Left rear indicator",
                "Left rear suspension",
                "Left rear brake"
            ],
            "mbBackRight": [
                "Right side engine",
                "Right rear footrest",
                "Right side exhaust",
                "Right side frame",
                "Right rear indicator",
                "Right rear suspension",
                "Right rear brake"
            ],
            "mbBack": [
                "Carrier",
                "Exhaust",
                "Tail light",
                "Rear fairing",
                "Rear mudguard",
                "Rear shock",
                "Rear tyre",
                "Rear brake"
            ],
            "isInEdit": false,
            "incidentEventList": [
                {
                    "id": 12,
                    "description": "Collided with an animal"
                },
                {
                    "id": 676,
                    "description": "Collided with a pedestrian"
                },
                {
                    "id": 21,
                    "description": "Tyre burst and hit an object/vehicle"
                },
                {
                    "id": 13,
                    "description": "Collided with another vehicle"
                },
                {
                    "id": 11,
                    "description": "Pothole"
                },
                {
                    "id": 14,
                    "description": "Collided with an object (not another vehicle)"
                }
            ],
            "incidentEventType": {
                "id": 13,
                "description": "Collided with another vehicle"
            },
            "photoList": "",
            "incidentDate": "01-11-2022",
            "incidentTime": "13:00",
            "contactName": "Styling User",
            "contactNumber": "0820000000",
            "whereDescription": "Where",
            "addressLat": 37.774929,
            "whatDescription": "What",
            "extraDescription": "",
            "isDriveavle": true,
            "claimNumber": "",
            "lastCompletedStep": 10,
            "lastCompletedSubStep": 1,
            "IsIncidentDateClicked": false,
            "time": "13:00",
            "timeDisplay": "1:00 pm",
            "continueOnMobile": false,
            "showDisclaimer": false,
            "claimStatus": "",
            "hasSmashAndGrab": false,
            "glassDamage": false,
            "isRepaired": false,
            "glassSubmitDisabled": false,
            "hasBeenRepaired": false,
            "claimExcess": 0,
            "glassDrillDown": false,
            "selectedGlassDrilldown": "",
            "lastSelectedDamage": "Bonnet",
            "repairStepValid": false,
            "replacementExcessDescription": "",
            "repairExcessDescription": "",
            "isStationary": "no", "isDriverInjured" : false,
            "regularDriver": {
                "id": null,
                "claimCarId": null,
                "claimCarDriverTypeId": 1,
                "regularDriverId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "copyRegularDriver": true,
                "customerId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "firstName": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "idTypeId": 0,
                "contactId": null,
                "cellPhone": null,
                "homePhone": null,
                "workPhone": null,
                "addressId": null,
                "addressLine1": null,
                "addressLine2": null,
                "suburb": null,
                "city": null,
                "province": null,
                "postalCode": null,
                "relationshipId": null,
                "regularDriverDate": null,
                "licenseTypeId": null,
                "licenseCode": null,
                "licenseIssueDate": null,
                "licenseRestriction": null,
                "driverIdTypeId": null,
                "driverTypeId": 0,
                "countryId": null,
                "hasConsentRegularDriverItcCheck": false,
                "emailAddress": null,
                "vehicleMakeId": null,
                "vehicleModelId": null,
                "vehicleSeriesId": null,
                "vehicleYear": null,
                "regularDriverAddress": null,
                "claimMotorbikeDriverTypeId": 0,
                "claimWatercraftDriverTypeId": 0,
                "claimMotorbikeId": null,
                "motorbikeMakeId": null,
                "motorbikeModelId": null,
                "motorbikeSeriesId": null,
                "motorbikeYear": null,
                "hasSkipper": null,
                "claimWatercraftId": "00000000-0000-0000-0000-000000000000",
                "relationshipTypeDescription": null,
                "driverDateOfBirth": null,
                "driverVehicleRelationshipId": null
            },
            "driverDropdown": [
                {
                    "isPolicyHolder": true,
                    "isRegularDriver": true,
                    "name": "Styling",
                    "surname": "User",
                    "idNumber": "6909211760083",
                    "order": 1
                },
                {
                    "isPolicyHolder": false,
                    "isRegularDriver": false,
                    "name": "None of the listed drivers",
                    "surname": "",
                    "idNumber": "",
                    "order": 3
                }
            ],
            "policeReported": null,
            "policeReportNumber": "1234",
            "policeReportStation": "Menly",
            "blackListed": null,
            "blackListNumber": "",
            "claimDriver": {
                "isPolicyHolder": true,
                "isRegularDriver": true,
                "name": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "order": 1
            },
            "claimVehicleRegNo": "FRV516FS",
            "vehicleRegistrationConfirm": true,
            "isVehicleFinanced": "no",
            "selectedFinanceHouse": "",
            "claimVehicleTypes": [],
            "stolenLocations": [],
            "forcedEntryType": [],
            "contactPersonFullName": "Not given",
            "contactPersonNumber": "",
            "isResponsiblePersonMemberOfHousehold": null,
            "responsiblePersonFullName": "Not given",
            "responsiblePersonContactNumber": "",
            "deliveryLocationLongitude": 0,
            "deliveryLocationLatitude": 0,
            "selectedTypeOfCarId": null,
            "isVisibleSignsOfEntryIntoCar": null,
            "selectedEntryGainedId": null,
            "selectedWhereInTheCarId": null,
            "newDeviceName": "",
            "roadSurfaceTypes": [],
            "selectedRoadSurfaceTypes": "",
            "roadConditions": [],
            "selectedRoadConditions": "",
            "damageCauses": [
                {
                    "id": 45,
                    "description": "4 way stop",
                    "isActive": true
                },
                {
                    "id": 39,
                    "description": "Head on",
                    "isActive": true
                },
                {
                    "id": 40,
                    "description": "Lane change",
                    "isActive": true
                },
                {
                    "id": 37,
                    "description": "Rear ender",
                    "isActive": true
                },
                {
                    "id": 41,
                    "description": "Reversed",
                    "isActive": true
                },
                {
                    "id": 42,
                    "description": "Reversed simultaneously",
                    "isActive": true
                },
                {
                    "id": 43,
                    "description": "Right hand turn",
                    "isActive": true
                },
                {
                    "id": 44,
                    "description": "Robot controlled intersection",
                    "isActive": true
                },
                {
                    "id": 46,
                    "description": "Through road stop",
                    "isActive": true
                },
                {
                    "id": 47,
                    "description": "U-turn",
                    "isActive": true
                }
            ],
            "selectedDamageCauses": "",
            "insuranceCompanies": [],
            "selectedInsuranceCompany": "",
            "hasWitnesses": undefined,
            "hasThirdParties": undefined,
            "hasPassanger": undefined,
            "thirdPartyUnknownReason": "",
            "followUp": true,
            "followUpType": "multiple-collision",
            "partyErrorList": [],
            "stepLabel": 1
        }
        this.props.dispatchAction(setFnolReducerPayload(steps));
        this.props.dispatchAction(setFollowUpSteps(SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE));
        this.props.dispatchAction(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    async goPothole() {
        var steps = {
            "fnolStep": 1,
            "fnolSubStep": 4,
            "nextFnolSubStep": 1,
            "nextFnolStep": 1,
            "claimType": "CLAIM_TYPE_NORMAL",
            "selectedClaimStep": {
                "maxSubSteps": 1,
                "stepLabel": 1,
                "step": 1,
                "subStep": 1,
                "maxMobileSubSteps": 1,
                "title": "Road surface",
                "subTitle": "We need a few more details"
            },
            "fnolStepConfiguration": {
                "steps": [
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 1,
                        "step": 1,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Road surface",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 2,
                        "step": 2,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Passengers/witnesses",
                        "subTitle": "We need a few more details"
                    }
                ]
            },
            "isCar": true,
            "hasDamageSelected": true,
            "claimDamagePhotoTypes": [
                {
                    "id": 4,
                    "location": "front",
                    "description": "Front",
                    "imageName": "car-front",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 5,
                    "location": "front",
                    "description": "Windscreen",
                    "imageName": "car-windscreen",
                    "photoData": "",
                    "isSelected": true
                },
                {
                    "id": 6,
                    "location": "front",
                    "description": "Bonnet",
                    "imageName": "car-bonnet",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 7,
                    "location": "frontLeft",
                    "description": "Front left",
                    "imageName": "car-frontleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 8,
                    "location": "frontLeft",
                    "description": "Front left door",
                    "imageName": "car-frontleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 9,
                    "location": "frontLeft",
                    "description": "Front left window",
                    "imageName": "car-frontleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 10,
                    "location": "frontLeft",
                    "description": "Front left tyre",
                    "imageName": "car-frontlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 11,
                    "location": "frontRight",
                    "description": "Front right",
                    "imageName": "car-frontright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 12,
                    "location": "frontRight",
                    "description": "Front right door",
                    "imageName": "car-frontrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 13,
                    "location": "frontRight",
                    "description": "Front right window",
                    "imageName": "car-frontrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 14,
                    "location": "frontRight",
                    "description": "Front right tyre",
                    "imageName": "car-frontrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 15,
                    "location": "backLeft",
                    "description": "Back left",
                    "imageName": "car-backleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 16,
                    "location": "backLeft",
                    "description": "Back left door",
                    "imageName": "car-backleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 17,
                    "location": "backLeft",
                    "description": "Back left window",
                    "imageName": "car-backleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 18,
                    "location": "backLeft",
                    "description": "Back left tyre",
                    "imageName": "car-backlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 19,
                    "location": "backRight",
                    "description": "Back right",
                    "imageName": "car-backright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 20,
                    "location": "backRight",
                    "description": "Back right door",
                    "imageName": "car-backrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 21,
                    "location": "backRight",
                    "description": "Back right window",
                    "imageName": "car-backrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 22,
                    "location": "backRight",
                    "description": "Back right tyre",
                    "imageName": "car-backrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 23,
                    "location": "back",
                    "description": "Back",
                    "imageName": "car-back",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 24,
                    "location": "back",
                    "description": "Back window",
                    "imageName": "car-backwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 25,
                    "location": "back",
                    "description": "Boot",
                    "imageName": "car-boot",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 65,
                    "location": "special",
                    "description": "Undercarriage damage",
                    "imageName": "car-undercarriagedamage",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 66,
                    "location": "special",
                    "description": "Interior",
                    "imageName": "car-interior",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 67,
                    "location": "special",
                    "description": "Airbag popped",
                    "imageName": "car-airbagpopped",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 68,
                    "location": "special",
                    "description": "Sunroof",
                    "imageName": "car-sunroof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 69,
                    "location": "special",
                    "description": "Roof",
                    "imageName": "car-roof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 70,
                    "location": "special",
                    "description": "Locks",
                    "imageName": "car-locks",
                    "photoData": "",
                    "isSelected": false
                }
            ],
            "selectedDamagePhotoTypes": [],
            "damageListCar": {
                "damageFront": true,
                "damageFrontLeft": false,
                "damageFrontRight": false,
                "damageBackLeft": false,
                "damageBackRight": false,
                "damageBack": false,
                "damageExtras": false
            },
            "selectedRiskItem": {
                "isMainline": true,
                "image": "car",
                "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                "excess": "4500.00",
                "productId": "4c0cb071-42dd-4060-99ff-9f0214113451",
                "productName": "Car",
                "product": 1,
                "riskItems": [
                    {
                        "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                        "riskItemId": "3dc7fad9-dd76-4df8-816d-adc100b35dd8",
                        "description": "2020 BMW 220D M SPORT A/T(F22)",
                        "premium": "3303.71",
                        "excess": "4500.00",
                        "excessDescription": null,
                        "insuredForValue": null,
                        "regularDriver": {
                            "firstName": "Styling",
                            "surname": "User",
                            "gender": "F",
                            "idNumber": "6909211760083",
                            "dateOfBirth": "21 September 1969",
                            "licenseCode": "Code C - Truck > 16,000kg",
                            "licenseIssueDate": "June 2006"
                        },
                        "vehicleDetails": {
                            "registrationNumber": "FRV516FS",
                            "vinNumber": "Not provided",
                            "engineNumber": "Not provided",
                            "year": 2020,
                            "colour": "Not provided",
                            "vehicleImported": "No",
                            "vehicleUse": "Not provided",
                            "vehicleMake": "BMW",
                            "vehicleModel": "2 SERIES",
                            "mmCode": null,
                            "vehicleModified": null,
                            "vehicleRegisteredLocally": null,
                            "approximateKilometers": 0,
                            "fullServiceHistory": null,
                            "vehicleSeries": "220D M SPORT A/T(F22)"
                        },
                        "chilliDetails": null,
                        "watercraftDetails": null,
                        "warrantyDetails": null,
                        "portablePossessions": [],
                        "blingBrandNewCovers": [],
                        "blingLikeNewCovers": [],
                        "blingScreenFixCovers": [],
                        "address": {
                            "oneLineAddress": null,
                            "twoLineAddress": null,
                            "fullAddress": "478 Pretoria Street, SILVERTON, 0184",
                            "dayAddress": ""
                        },
                        "inspectionRequired": true,
                        "insuranceDuration": "6 years",
                        "numberOfClaims": 0,
                        "lastStolenClaim": "Not Provided",
                        "lastAccidentClaim": "13 - 24 months (1 - 2 years)",
                        "existingWarranty": null,
                        "personalAccidentCoverValue": null,
                        "hasError": false,
                        "coverStartDate": "14-10-2021"
                    }
                ],
                "accessories": [
                    {
                        "id": 29,
                        "replacementValue": 2100,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "We'll replace your windscreen film as long as it's insured with the king.",
                        "title": "Smash and grab",
                        "subtitle": "2100.00",
                        "icon": "icons-vap-icons-smash-and-grab-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 28,
                        "replacementValue": 2300,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Sunroof",
                        "subtitle": "2300.00",
                        "icon": "icons-vap-icons-sunroof-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 2,
                        "replacementValue": 2000,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "You chose them, we'll cover them. Tell us how much they're worth and we'll handle the rest!",
                        "title": "Mags and rims",
                        "subtitle": "2000.00",
                        "icon": "icons-vap-icons-mags-and-rims-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 26,
                        "replacementValue": 2200,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Leather seats",
                        "subtitle": "2200.00",
                        "icon": "icons-vap-icons-leather-seats-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    }
                ],
                "vaps": [
                    {
                        "id": "0ec1dcaa-a6f7-4c86-905a-00fd55022569",
                        "vapTypeId": 1,
                        "premium": 75,
                        "isActive": true,
                        "description": "Covers minor repairs to the exterior of your car ... Like those mysterious dings that 'just happen'.",
                        "title": "Scratch and dent",
                        "icon": "icons-vap-icons-scratch-and-dent-active",
                        "reasonRequired": true,
                        "premiumText": "75.00",
                        "enabled": true
                    },
                    {
                        "id": "916e328e-ad96-4d6c-a3e8-42b095bcb805",
                        "vapTypeId": 2,
                        "premium": 39,
                        "isActive": true,
                        "description": "From rocks, to glass to other road hazards… We’ll make sure your tyres and rims keep going round and round, no matter the damage",
                        "title": "Tyre and Rim",
                        "icon": "icons-vap-icons-tyre-and-rim-active",
                        "reasonRequired": true,
                        "premiumText": "39.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113460",
                        "vapTypeId": 1,
                        "premium": 19.5,
                        "isActive": true,
                        "description": "Offers you (and your car) a safe ride home, when driving yourself just isn't a good idea.",
                        "title": "Kings Cab",
                        "icon": "icons-vap-icons-kings-cab-active",
                        "reasonRequired": true,
                        "premiumText": "19.50",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113461",
                        "vapTypeId": 2,
                        "premium": 129,
                        "isActive": true,
                        "description": "This ensures that you'll have rental wheels for 30 days when your own are being repaired by 1 of our suppliers following a successful claim.",
                        "title": "Car Hire",
                        "icon": "icons-vap-icons-car-hire-active",
                        "reasonRequired": true,
                        "premiumText": "129.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113467",
                        "vapTypeId": 3,
                        "premium": 116.29,
                        "isActive": true,
                        "description": "Covers the difference between what your car/motorbike is worth at the time of it being stolen or written off, and what you still owe on it.",
                        "title": "Credit Shortfall",
                        "icon": "icons-vap-icons-credit-shortfall-active",
                        "reasonRequired": true,
                        "premiumText": "116.29",
                        "enabled": true
                    }
                ],
                "accesoriesTotal": 8600,
                "policyCoverId": "54ced8d9-2135-41ad-a56c-adc100b3f7af"
            },
            "incidentType": {
                "id": 1,
                "description": "Collision"
            },
            "mbFront": [
                "Front fairing",
                "Front mudguard",
                "Windshield",
                "Headlight",
                "Front tyre",
                "Handlebars",
                "Front brake"
            ],
            "mbFrontLeft": [
                "Left shock",
                "Left indicator",
                "Left mirror",
                "Left fairing",
                "Clutch lever",
                "Left front footrest",
                "Gear lever",
                "Front left brake"
            ],
            "mbFrontRight": [
                "Right shock",
                "Right indicator",
                "Right mirror",
                "Right fairing",
                "Front brake lever",
                "Right front footrest",
                "Right front brake"
            ],
            "mbBackLeft": [
                "Left side engine",
                "Left rear footrest",
                "Left side exhaust",
                "Left side frame",
                "Left rear indicator",
                "Left rear suspension",
                "Left rear brake"
            ],
            "mbBackRight": [
                "Right side engine",
                "Right rear footrest",
                "Right side exhaust",
                "Right side frame",
                "Right rear indicator",
                "Right rear suspension",
                "Right rear brake"
            ],
            "mbBack": [
                "Carrier",
                "Exhaust",
                "Tail light",
                "Rear fairing",
                "Rear mudguard",
                "Rear shock",
                "Rear tyre",
                "Rear brake"
            ],
            "isInEdit": false,
            "incidentEventList": [
                {
                    "id": 12,
                    "description": "Collided with an animal"
                },
                {
                    "id": 676,
                    "description": "Collided with a pedestrian"
                },
                {
                    "id": 21,
                    "description": "Tyre burst and hit an object/vehicle"
                },
                {
                    "id": 13,
                    "description": "Collided with another vehicle"
                },
                {
                    "id": 11,
                    "description": "Pothole"
                },
                {
                    "id": 14,
                    "description": "Collided with an object (not another vehicle)"
                }
            ],
            "incidentEventType": {
                "id": 11,
                "description": "Pothole"
            },
            "photoList": "",
            "incidentDate": "02-11-2022",
            "incidentTime": "13:00",
            "contactName": "Styling User",
            "contactNumber": "0820000000",
            "whereDescription": "1234",
            "addressLat": 37.774929,
            "whatDescription": "Wut",
            "extraDescription": "",
            "isDriveavle": true,
            "claimNumber": "",
            "lastCompletedStep": 10,
            "lastCompletedSubStep": 1,
            "IsIncidentDateClicked": false,
            "time": "13:00",
            "timeDisplay": "1:00 pm",
            "continueOnMobile": false,
            "showDisclaimer": false,
            "claimStatus": "",
            "hasSmashAndGrab": false,
            "glassDamage": false,
            "isRepaired": false,
            "glassSubmitDisabled": false,
            "hasBeenRepaired": false,
            "claimExcess": 0,
            "glassDrillDown": false,
            "selectedGlassDrilldown": "",
            "lastSelectedDamage": "Windscreen",
            "repairStepValid": false,
            "replacementExcessDescription": "",
            "repairExcessDescription": "",
            "isStationary": "no", "isDriverInjured" : false,
            "regularDriver": {
                "id": null,
                "claimCarId": null,
                "claimCarDriverTypeId": 1,
                "regularDriverId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "copyRegularDriver": true,
                "customerId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "firstName": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "idTypeId": 0,
                "contactId": null,
                "cellPhone": null,
                "homePhone": null,
                "workPhone": null,
                "addressId": null,
                "addressLine1": null,
                "addressLine2": null,
                "suburb": null,
                "city": null,
                "province": null,
                "postalCode": null,
                "relationshipId": null,
                "regularDriverDate": null,
                "licenseTypeId": null,
                "licenseCode": null,
                "licenseIssueDate": null,
                "licenseRestriction": null,
                "driverIdTypeId": null,
                "driverTypeId": 0,
                "countryId": null,
                "hasConsentRegularDriverItcCheck": false,
                "emailAddress": null,
                "vehicleMakeId": null,
                "vehicleModelId": null,
                "vehicleSeriesId": null,
                "vehicleYear": null,
                "regularDriverAddress": null,
                "claimMotorbikeDriverTypeId": 0,
                "claimWatercraftDriverTypeId": 0,
                "claimMotorbikeId": null,
                "motorbikeMakeId": null,
                "motorbikeModelId": null,
                "motorbikeSeriesId": null,
                "motorbikeYear": null,
                "hasSkipper": null,
                "claimWatercraftId": "00000000-0000-0000-0000-000000000000",
                "relationshipTypeDescription": null,
                "driverDateOfBirth": null,
                "driverVehicleRelationshipId": null
            },
            "driverDropdown": [
                {
                    "isPolicyHolder": true,
                    "isRegularDriver": true,
                    "name": "Styling",
                    "surname": "User",
                    "idNumber": "6909211760083",
                    "order": 1
                },
                {
                    "isPolicyHolder": false,
                    "isRegularDriver": false,
                    "name": "None of the listed drivers",
                    "surname": "",
                    "idNumber": "",
                    "order": 3
                }
            ],
            "policeReported": null,
            "policeReportNumber": "1234",
            "policeReportStation": "Police",
            "blackListed": null,
            "blackListNumber": "",
            "claimDriver": {
                "isPolicyHolder": true,
                "isRegularDriver": true,
                "name": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "order": 1
            },
            "claimVehicleRegNo": "FRV516FS",
            "vehicleRegistrationConfirm": true,
            "isVehicleFinanced": "no",
            "selectedFinanceHouse": "",
            "claimVehicleTypes": [],
            "stolenLocations": [],
            "forcedEntryType": [],
            "contactPersonFullName": "Not given",
            "contactPersonNumber": "",
            "isResponsiblePersonMemberOfHousehold": null,
            "responsiblePersonFullName": "Not given",
            "responsiblePersonContactNumber": "",
            "deliveryLocationLongitude": 0,
            "deliveryLocationLatitude": 0,
            "selectedTypeOfCarId": null,
            "isVisibleSignsOfEntryIntoCar": null,
            "selectedEntryGainedId": null,
            "selectedWhereInTheCarId": null,
            "newDeviceName": "",
            "roadSurfaceTypes": [
                {
                    "id": 1,
                    "description": "Tar"
                },
                {
                    "id": 2,
                    "description": "Gravel"
                },
                {
                    "id": 3,
                    "description": "Cement"
                },
                {
                    "id": 4,
                    "description": "Dirt"
                },
                {
                    "id": 5,
                    "description": "Grass"
                }
            ],
            "selectedRoadSurfaceTypes": "",
            "roadConditions": [
                {
                    "id": 1,
                    "description": "Dry"
                },
                {
                    "id": 2,
                    "description": "Wet"
                },
                {
                    "id": 3,
                    "description": "Oil"
                },
                {
                    "id": 4,
                    "description": "Potholes"
                },
                {
                    "id": 5,
                    "description": "Sinkholes"
                }
            ],
            "selectedRoadConditions": "",
            "damageCauses": [],
            "selectedDamageCauses": "",
            "insuranceCompanies": [],
            "selectedInsuranceCompany": "",
            "hasWitnesses": false,
            "hasPassanger": false,
            "thirdPartyUnknownReason": "",
            "followUp": true,
            "followUpType": "pothole",
            "partyErrorList": [],
            "stepLabel": 1
        };
        this.props.dispatchAction(setFnolReducerPayload(steps));
        this.props.dispatchAction(setFollowUpSteps(SET_STEPS_FOLLOW_UP_PEDESTRIAN));
        this.props.dispatchAction(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    async goPedestrian() {
        var steps = {
            "fnolStep": 1,
            "fnolSubStep": 4,
            "nextFnolSubStep": 1,
            "nextFnolStep": 1,
            "claimType": "CLAIM_TYPE_NORMAL",
            "selectedClaimStep": {
                "maxSubSteps": 1,
                "stepLabel": 1,
                "step": 1,
                "subStep": 1,
                "maxMobileSubSteps": 1,
                "title": "Road surface",
                "subTitle": "We need a few more details"
            },
            "fnolStepConfiguration": {
                "steps": [
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 1,
                        "step": 2,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Road surface",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 2,
                        "step": 3,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Pedestrians",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 3,
                        "step": 4,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Passengers/witnesses",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 4,
                        "step": 5,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Injured party/parties",
                        "subTitle": "We need a few more details"
                    }
                ]
            },
            "isCar": true,
            "hasDamageSelected": true,
            "claimDamagePhotoTypes": [
                {
                    "id": 4,
                    "location": "front",
                    "description": "Front",
                    "imageName": "car-front",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 5,
                    "location": "front",
                    "description": "Windscreen",
                    "imageName": "car-windscreen",
                    "photoData": "",
                    "isSelected": true
                },
                {
                    "id": 6,
                    "location": "front",
                    "description": "Bonnet",
                    "imageName": "car-bonnet",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 7,
                    "location": "frontLeft",
                    "description": "Front left",
                    "imageName": "car-frontleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 8,
                    "location": "frontLeft",
                    "description": "Front left door",
                    "imageName": "car-frontleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 9,
                    "location": "frontLeft",
                    "description": "Front left window",
                    "imageName": "car-frontleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 10,
                    "location": "frontLeft",
                    "description": "Front left tyre",
                    "imageName": "car-frontlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 11,
                    "location": "frontRight",
                    "description": "Front right",
                    "imageName": "car-frontright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 12,
                    "location": "frontRight",
                    "description": "Front right door",
                    "imageName": "car-frontrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 13,
                    "location": "frontRight",
                    "description": "Front right window",
                    "imageName": "car-frontrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 14,
                    "location": "frontRight",
                    "description": "Front right tyre",
                    "imageName": "car-frontrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 15,
                    "location": "backLeft",
                    "description": "Back left",
                    "imageName": "car-backleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 16,
                    "location": "backLeft",
                    "description": "Back left door",
                    "imageName": "car-backleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 17,
                    "location": "backLeft",
                    "description": "Back left window",
                    "imageName": "car-backleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 18,
                    "location": "backLeft",
                    "description": "Back left tyre",
                    "imageName": "car-backlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 19,
                    "location": "backRight",
                    "description": "Back right",
                    "imageName": "car-backright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 20,
                    "location": "backRight",
                    "description": "Back right door",
                    "imageName": "car-backrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 21,
                    "location": "backRight",
                    "description": "Back right window",
                    "imageName": "car-backrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 22,
                    "location": "backRight",
                    "description": "Back right tyre",
                    "imageName": "car-backrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 23,
                    "location": "back",
                    "description": "Back",
                    "imageName": "car-back",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 24,
                    "location": "back",
                    "description": "Back window",
                    "imageName": "car-backwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 25,
                    "location": "back",
                    "description": "Boot",
                    "imageName": "car-boot",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 65,
                    "location": "special",
                    "description": "Undercarriage damage",
                    "imageName": "car-undercarriagedamage",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 66,
                    "location": "special",
                    "description": "Interior",
                    "imageName": "car-interior",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 67,
                    "location": "special",
                    "description": "Airbag popped",
                    "imageName": "car-airbagpopped",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 68,
                    "location": "special",
                    "description": "Sunroof",
                    "imageName": "car-sunroof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 69,
                    "location": "special",
                    "description": "Roof",
                    "imageName": "car-roof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 70,
                    "location": "special",
                    "description": "Locks",
                    "imageName": "car-locks",
                    "photoData": "",
                    "isSelected": false
                }
            ],
            "selectedDamagePhotoTypes": [],
            "damageListCar": {
                "damageFront": true,
                "damageFrontLeft": false,
                "damageFrontRight": false,
                "damageBackLeft": false,
                "damageBackRight": false,
                "damageBack": false,
                "damageExtras": false
            },
            "selectedRiskItem": {
                "isMainline": true,
                "image": "car",
                "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                "excess": "4500.00",
                "productId": "4c0cb071-42dd-4060-99ff-9f0214113451",
                "productName": "Car",
                "product": 1,
                "riskItems": [
                    {
                        "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                        "riskItemId": "3dc7fad9-dd76-4df8-816d-adc100b35dd8",
                        "description": "2020 BMW 220D M SPORT A/T(F22)",
                        "premium": "3303.71",
                        "excess": "4500.00",
                        "excessDescription": null,
                        "insuredForValue": null,
                        "regularDriver": {
                            "firstName": "Styling",
                            "surname": "User",
                            "gender": "F",
                            "idNumber": "6909211760083",
                            "dateOfBirth": "21 September 1969",
                            "licenseCode": "Code C - Truck > 16,000kg",
                            "licenseIssueDate": "June 2006"
                        },
                        "vehicleDetails": {
                            "registrationNumber": "FRV516FS",
                            "vinNumber": "Not provided",
                            "engineNumber": "Not provided",
                            "year": 2020,
                            "colour": "Not provided",
                            "vehicleImported": "No",
                            "vehicleUse": "Not provided",
                            "vehicleMake": "BMW",
                            "vehicleModel": "2 SERIES",
                            "mmCode": null,
                            "vehicleModified": null,
                            "vehicleRegisteredLocally": null,
                            "approximateKilometers": 0,
                            "fullServiceHistory": null,
                            "vehicleSeries": "220D M SPORT A/T(F22)"
                        },
                        "chilliDetails": null,
                        "watercraftDetails": null,
                        "warrantyDetails": null,
                        "portablePossessions": [],
                        "blingBrandNewCovers": [],
                        "blingLikeNewCovers": [],
                        "blingScreenFixCovers": [],
                        "address": {
                            "oneLineAddress": null,
                            "twoLineAddress": null,
                            "fullAddress": "478 Pretoria Street, SILVERTON, 0184",
                            "dayAddress": ""
                        },
                        "inspectionRequired": true,
                        "insuranceDuration": "6 years",
                        "numberOfClaims": 0,
                        "lastStolenClaim": "Not Provided",
                        "lastAccidentClaim": "13 - 24 months (1 - 2 years)",
                        "existingWarranty": null,
                        "personalAccidentCoverValue": null,
                        "hasError": false,
                        "coverStartDate": "14-10-2021"
                    }
                ],
                "accessories": [
                    {
                        "id": 29,
                        "replacementValue": 2100,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "We'll replace your windscreen film as long as it's insured with the king.",
                        "title": "Smash and grab",
                        "subtitle": "2100.00",
                        "icon": "icons-vap-icons-smash-and-grab-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 28,
                        "replacementValue": 2300,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Sunroof",
                        "subtitle": "2300.00",
                        "icon": "icons-vap-icons-sunroof-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 2,
                        "replacementValue": 2000,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "You chose them, we'll cover them. Tell us how much they're worth and we'll handle the rest!",
                        "title": "Mags and rims",
                        "subtitle": "2000.00",
                        "icon": "icons-vap-icons-mags-and-rims-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 26,
                        "replacementValue": 2200,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Leather seats",
                        "subtitle": "2200.00",
                        "icon": "icons-vap-icons-leather-seats-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    }
                ],
                "vaps": [
                    {
                        "id": "0ec1dcaa-a6f7-4c86-905a-00fd55022569",
                        "vapTypeId": 1,
                        "premium": 75,
                        "isActive": true,
                        "description": "Covers minor repairs to the exterior of your car ... Like those mysterious dings that 'just happen'.",
                        "title": "Scratch and dent",
                        "icon": "icons-vap-icons-scratch-and-dent-active",
                        "reasonRequired": true,
                        "premiumText": "75.00",
                        "enabled": true
                    },
                    {
                        "id": "916e328e-ad96-4d6c-a3e8-42b095bcb805",
                        "vapTypeId": 2,
                        "premium": 39,
                        "isActive": true,
                        "description": "From rocks, to glass to other road hazards… We’ll make sure your tyres and rims keep going round and round, no matter the damage",
                        "title": "Tyre and Rim",
                        "icon": "icons-vap-icons-tyre-and-rim-active",
                        "reasonRequired": true,
                        "premiumText": "39.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113460",
                        "vapTypeId": 1,
                        "premium": 19.5,
                        "isActive": true,
                        "description": "Offers you (and your car) a safe ride home, when driving yourself just isn't a good idea.",
                        "title": "Kings Cab",
                        "icon": "icons-vap-icons-kings-cab-active",
                        "reasonRequired": true,
                        "premiumText": "19.50",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113461",
                        "vapTypeId": 2,
                        "premium": 129,
                        "isActive": true,
                        "description": "This ensures that you'll have rental wheels for 30 days when your own are being repaired by 1 of our suppliers following a successful claim.",
                        "title": "Car Hire",
                        "icon": "icons-vap-icons-car-hire-active",
                        "reasonRequired": true,
                        "premiumText": "129.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113467",
                        "vapTypeId": 3,
                        "premium": 116.29,
                        "isActive": true,
                        "description": "Covers the difference between what your car/motorbike is worth at the time of it being stolen or written off, and what you still owe on it.",
                        "title": "Credit Shortfall",
                        "icon": "icons-vap-icons-credit-shortfall-active",
                        "reasonRequired": true,
                        "premiumText": "116.29",
                        "enabled": true
                    }
                ],
                "accesoriesTotal": 8600,
                "policyCoverId": "54ced8d9-2135-41ad-a56c-adc100b3f7af"
            },
            "incidentType": {
                "id": 1,
                "description": "Collision"
            },
            "mbFront": [
                "Front fairing",
                "Front mudguard",
                "Windshield",
                "Headlight",
                "Front tyre",
                "Handlebars",
                "Front brake"
            ],
            "mbFrontLeft": [
                "Left shock",
                "Left indicator",
                "Left mirror",
                "Left fairing",
                "Clutch lever",
                "Left front footrest",
                "Gear lever",
                "Front left brake"
            ],
            "mbFrontRight": [
                "Right shock",
                "Right indicator",
                "Right mirror",
                "Right fairing",
                "Front brake lever",
                "Right front footrest",
                "Right front brake"
            ],
            "mbBackLeft": [
                "Left side engine",
                "Left rear footrest",
                "Left side exhaust",
                "Left side frame",
                "Left rear indicator",
                "Left rear suspension",
                "Left rear brake"
            ],
            "mbBackRight": [
                "Right side engine",
                "Right rear footrest",
                "Right side exhaust",
                "Right side frame",
                "Right rear indicator",
                "Right rear suspension",
                "Right rear brake"
            ],
            "mbBack": [
                "Carrier",
                "Exhaust",
                "Tail light",
                "Rear fairing",
                "Rear mudguard",
                "Rear shock",
                "Rear tyre",
                "Rear brake"
            ],
            "isInEdit": false,
            "incidentEventList": [
                {
                    "id": 12,
                    "description": "Collided with an animal"
                },
                {
                    "id": 676,
                    "description": "Collided with a pedestrian"
                },
                {
                    "id": 21,
                    "description": "Tyre burst and hit an object/vehicle"
                },
                {
                    "id": 13,
                    "description": "Collided with another vehicle"
                },
                {
                    "id": 11,
                    "description": "Pothole"
                },
                {
                    "id": 14,
                    "description": "Collided with an object (not another vehicle)"
                }
            ],
            "incidentEventType": {
                "id": 676,
                "description": "Collided with a pedestrian"
            },
            "photoList": "",
            "incidentDate": "02-11-2022",
            "incidentTime": "13:00",
            "contactName": "Styling User",
            "contactNumber": "0820000000",
            "whereDescription": "1234",
            "addressLat": 37.774929,
            "whatDescription": "Wut",
            "extraDescription": "",
            "isDriveavle": true,
            "claimNumber": "",
            "lastCompletedStep": 10,
            "lastCompletedSubStep": 1,
            "IsIncidentDateClicked": false,
            "time": "13:00",
            "timeDisplay": "1:00 pm",
            "continueOnMobile": false,
            "showDisclaimer": false,
            "claimStatus": "",
            "hasSmashAndGrab": false,
            "glassDamage": false,
            "isRepaired": false,
            "glassSubmitDisabled": false,
            "hasBeenRepaired": false,
            "claimExcess": 0,
            "glassDrillDown": false,
            "selectedGlassDrilldown": "",
            "lastSelectedDamage": "Windscreen",
            "repairStepValid": false,
            "replacementExcessDescription": "",
            "repairExcessDescription": "",
            "isStationary": "no", "isDriverInjured" : false,
            "regularDriver": {
                "id": null,
                "claimCarId": null,
                "claimCarDriverTypeId": 1,
                "regularDriverId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "copyRegularDriver": true,
                "customerId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "firstName": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "idTypeId": 0,
                "contactId": null,
                "cellPhone": null,
                "homePhone": null,
                "workPhone": null,
                "addressId": null,
                "addressLine1": null,
                "addressLine2": null,
                "suburb": null,
                "city": null,
                "province": null,
                "postalCode": null,
                "relationshipId": null,
                "regularDriverDate": null,
                "licenseTypeId": null,
                "licenseCode": null,
                "licenseIssueDate": null,
                "licenseRestriction": null,
                "driverIdTypeId": null,
                "driverTypeId": 0,
                "countryId": null,
                "hasConsentRegularDriverItcCheck": false,
                "emailAddress": null,
                "vehicleMakeId": null,
                "vehicleModelId": null,
                "vehicleSeriesId": null,
                "vehicleYear": null,
                "regularDriverAddress": null,
                "claimMotorbikeDriverTypeId": 0,
                "claimWatercraftDriverTypeId": 0,
                "claimMotorbikeId": null,
                "motorbikeMakeId": null,
                "motorbikeModelId": null,
                "motorbikeSeriesId": null,
                "motorbikeYear": null,
                "hasSkipper": null,
                "claimWatercraftId": "00000000-0000-0000-0000-000000000000",
                "relationshipTypeDescription": null,
                "driverDateOfBirth": null,
                "driverVehicleRelationshipId": null
            },
            "driverDropdown": [
                {
                    "isPolicyHolder": true,
                    "isRegularDriver": true,
                    "name": "Styling",
                    "surname": "User",
                    "idNumber": "6909211760083",
                    "order": 1
                },
                {
                    "isPolicyHolder": false,
                    "isRegularDriver": false,
                    "name": "None of the listed drivers",
                    "surname": "",
                    "idNumber": "",
                    "order": 3
                }
            ],
            "policeReported": null,
            "policeReportNumber": "1234",
            "policeReportStation": "Police",
            "blackListed": null,
            "blackListNumber": "",
            "claimDriver": {
                "isPolicyHolder": true,
                "isRegularDriver": true,
                "name": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "order": 1
            },
            "claimVehicleRegNo": "FRV516FS",
            "vehicleRegistrationConfirm": true,
            "isVehicleFinanced": "no",
            "selectedFinanceHouse": "",
            "claimVehicleTypes": [],
            "stolenLocations": [],
            "forcedEntryType": [],
            "contactPersonFullName": "Not given",
            "contactPersonNumber": "",
            "isResponsiblePersonMemberOfHousehold": null,
            "responsiblePersonFullName": "Not given",
            "responsiblePersonContactNumber": "",
            "deliveryLocationLongitude": 0,
            "deliveryLocationLatitude": 0,
            "selectedTypeOfCarId": null,
            "isVisibleSignsOfEntryIntoCar": null,
            "selectedEntryGainedId": null,
            "selectedWhereInTheCarId": null,
            "newDeviceName": "",
            "roadSurfaceTypes": [
                {
                    "id": 1,
                    "description": "Tar"
                },
                {
                    "id": 2,
                    "description": "Gravel"
                },
                {
                    "id": 3,
                    "description": "Cement"
                },
                {
                    "id": 4,
                    "description": "Dirt"
                },
                {
                    "id": 5,
                    "description": "Grass"
                }
            ],
            "selectedRoadSurfaceTypes": "",
            "roadConditions": [
                {
                    "id": 1,
                    "description": "Dry"
                },
                {
                    "id": 2,
                    "description": "Wet"
                },
                {
                    "id": 3,
                    "description": "Oil"
                },
                {
                    "id": 4,
                    "description": "Potholes"
                },
                {
                    "id": 5,
                    "description": "Sinkholes"
                }
            ],
            "selectedRoadConditions": "",
            "damageCauses": [],
            "selectedDamageCauses": "",
            "insuranceCompanies": [],
            "selectedInsuranceCompany": "",
            "hasWitnesses": false,
            "hasPassanger": false,
            "thirdPartyUnknownReason": "",
            "followUp": true,
            "followUpType": "pothole",
            "partyErrorList": [],
            "stepLabel": 1
        };
        this.props.dispatchAction(setFnolReducerPayload(steps));
        this.props.dispatchAction(setFollowUpSteps(SET_STEPS_FOLLOW_UP_PEDESTRIAN));
        this.props.dispatchAction(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    async goFollowUpStationary() {
        let steps = {
            "fnolStep": 1,
            "fnolSubStep": 4,
            "nextFnolSubStep": 1,
            "nextFnolStep": 1,
            "claimType": "CLAIM_TYPE_NORMAL",
            "selectedClaimStep": {
                "maxSubSteps": 1,
                "stepLabel": 1,
                "step": 1,
                "subStep": 1,
                "maxMobileSubSteps": 1,
                "title": "Incident Info",
                "subTitle": "We need a few more details"
            },
            "fnolStepConfiguration": {
                "steps": [
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 1,
                        "step": 1,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Incident info",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 2,
                        "step": 3,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Other party/parties",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 3,
                        "step": 4,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Witnesses",
                        "subTitle": "We need a few more details"
                    },
                    {
                        "maxSubSteps": 1,
                        "stepLabel": 4,
                        "step": 5,
                        "subStep": 1,
                        "maxMobileSubSteps": 1,
                        "title": "Injured party/parties",
                        "subTitle": "We need a few more details"
                    }
                ]
            },
            "isCar": true,
            "hasDamageSelected": true,
            "claimDamagePhotoTypes": [
                {
                    "id": 4,
                    "location": "front",
                    "description": "Front",
                    "imageName": "car-front",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 5,
                    "location": "front",
                    "description": "Windscreen",
                    "imageName": "car-windscreen",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 6,
                    "location": "front",
                    "description": "Bonnet",
                    "imageName": "car-bonnet",
                    "photoData": "",
                    "isSelected": true
                },
                {
                    "id": 7,
                    "location": "frontLeft",
                    "description": "Front left",
                    "imageName": "car-frontleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 8,
                    "location": "frontLeft",
                    "description": "Front left door",
                    "imageName": "car-frontleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 9,
                    "location": "frontLeft",
                    "description": "Front left window",
                    "imageName": "car-frontleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 10,
                    "location": "frontLeft",
                    "description": "Front left tyre",
                    "imageName": "car-frontlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 11,
                    "location": "frontRight",
                    "description": "Front right",
                    "imageName": "car-frontright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 12,
                    "location": "frontRight",
                    "description": "Front right door",
                    "imageName": "car-frontrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 13,
                    "location": "frontRight",
                    "description": "Front right window",
                    "imageName": "car-frontrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 14,
                    "location": "frontRight",
                    "description": "Front right tyre",
                    "imageName": "car-frontrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 15,
                    "location": "backLeft",
                    "description": "Back left",
                    "imageName": "car-backleft",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 16,
                    "location": "backLeft",
                    "description": "Back left door",
                    "imageName": "car-backleftdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 17,
                    "location": "backLeft",
                    "description": "Back left window",
                    "imageName": "car-backleftwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 18,
                    "location": "backLeft",
                    "description": "Back left tyre",
                    "imageName": "car-backlefttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 19,
                    "location": "backRight",
                    "description": "Back right",
                    "imageName": "car-backright",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 20,
                    "location": "backRight",
                    "description": "Back right door",
                    "imageName": "car-backrightdoor",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 21,
                    "location": "backRight",
                    "description": "Back right window",
                    "imageName": "car-backrightwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 22,
                    "location": "backRight",
                    "description": "Back right tyre",
                    "imageName": "car-backrighttyre",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 23,
                    "location": "back",
                    "description": "Back",
                    "imageName": "car-back",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 24,
                    "location": "back",
                    "description": "Back window",
                    "imageName": "car-backwindow",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 25,
                    "location": "back",
                    "description": "Boot",
                    "imageName": "car-boot",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 65,
                    "location": "special",
                    "description": "Undercarriage damage",
                    "imageName": "car-undercarriagedamage",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 66,
                    "location": "special",
                    "description": "Interior",
                    "imageName": "car-interior",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 67,
                    "location": "special",
                    "description": "Airbag popped",
                    "imageName": "car-airbagpopped",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 68,
                    "location": "special",
                    "description": "Sunroof",
                    "imageName": "car-sunroof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 69,
                    "location": "special",
                    "description": "Roof",
                    "imageName": "car-roof",
                    "photoData": "",
                    "isSelected": false
                },
                {
                    "id": 70,
                    "location": "special",
                    "description": "Locks",
                    "imageName": "car-locks",
                    "photoData": "",
                    "isSelected": false
                }
            ],
            "selectedDamagePhotoTypes": [],
            "damageListCar": {
                "damageFront": true,
                "damageFrontLeft": false,
                "damageFrontRight": false,
                "damageBackLeft": false,
                "damageBackRight": false,
                "damageBack": false,
                "damageExtras": false
            },
            "selectedRiskItem": {
                "isMainline": true,
                "image": "car",
                "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                "excess": "4500.00",
                "productId": "4c0cb071-42dd-4060-99ff-9f0214113451",
                "productName": "Car",
                "product": 1,
                "riskItems": [
                    {
                        "id": "507f0e67-d350-4fb1-9ec0-adc100b3f7a6",
                        "riskItemId": "3dc7fad9-dd76-4df8-816d-adc100b35dd8",
                        "description": "2020 BMW 220D M SPORT A/T(F22)",
                        "premium": "3303.71",
                        "excess": "4500.00",
                        "excessDescription": null,
                        "insuredForValue": null,
                        "regularDriver": {
                            "firstName": "Styling",
                            "surname": "User",
                            "gender": "F",
                            "idNumber": "6909211760083",
                            "dateOfBirth": "21 September 1969",
                            "licenseCode": "Code C - Truck > 16,000kg",
                            "licenseIssueDate": "June 2006"
                        },
                        "vehicleDetails": {
                            "registrationNumber": "NOTPROVIDED",
                            "vinNumber": "Not provided",
                            "engineNumber": "Not provided",
                            "year": 2020,
                            "colour": "Not provided",
                            "vehicleImported": "No",
                            "vehicleUse": "Not provided",
                            "vehicleMake": "BMW",
                            "vehicleModel": "2 SERIES",
                            "mmCode": null,
                            "vehicleModified": null,
                            "vehicleRegisteredLocally": null,
                            "approximateKilometers": 0,
                            "fullServiceHistory": null,
                            "vehicleSeries": "220D M SPORT A/T(F22)"
                        },
                        "chilliDetails": null,
                        "watercraftDetails": null,
                        "warrantyDetails": null,
                        "portablePossessions": [],
                        "blingBrandNewCovers": [],
                        "blingLikeNewCovers": [],
                        "blingScreenFixCovers": [],
                        "address": {
                            "oneLineAddress": null,
                            "twoLineAddress": null,
                            "fullAddress": "478 Pretoria Street, SILVERTON, 0184",
                            "dayAddress": ""
                        },
                        "inspectionRequired": true,
                        "insuranceDuration": "6 years",
                        "numberOfClaims": 0,
                        "lastStolenClaim": "Not Provided",
                        "lastAccidentClaim": "13 - 24 months (1 - 2 years)",
                        "existingWarranty": null,
                        "personalAccidentCoverValue": null,
                        "hasError": false,
                        "coverStartDate": "14-10-2021"
                    }
                ],
                "accessories": [
                    {
                        "id": 29,
                        "replacementValue": 2100,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "We'll replace your windscreen film as long as it's insured with the king.",
                        "title": "Smash and grab",
                        "subtitle": "2100.00",
                        "icon": "icons-vap-icons-smash-and-grab-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 28,
                        "replacementValue": 2300,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Sunroof",
                        "subtitle": "2300.00",
                        "icon": "icons-vap-icons-sunroof-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 2,
                        "replacementValue": 2000,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": "You chose them, we'll cover them. Tell us how much they're worth and we'll handle the rest!",
                        "title": "Mags and rims",
                        "subtitle": "2000.00",
                        "icon": "icons-vap-icons-mags-and-rims-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    },
                    {
                        "id": 26,
                        "replacementValue": 2200,
                        "quoteCarAccessoryId": "00000000-0000-0000-0000-000000000000",
                        "quoteCoverId": "00000000-0000-0000-0000-000000000000",
                        "description": null,
                        "title": "Leather seats",
                        "subtitle": "2200.00",
                        "icon": "icons-vap-icons-leather-seats-active",
                        "outline": null,
                        "vapAccessory": 0,
                        "isActive": true
                    }
                ],
                "vaps": [
                    {
                        "id": "0ec1dcaa-a6f7-4c86-905a-00fd55022569",
                        "vapTypeId": 1,
                        "premium": 75,
                        "isActive": true,
                        "description": "Covers minor repairs to the exterior of your car ... Like those mysterious dings that 'just happen'.",
                        "title": "Scratch and dent",
                        "icon": "icons-vap-icons-scratch-and-dent-active",
                        "reasonRequired": true,
                        "premiumText": "75.00",
                        "enabled": true
                    },
                    {
                        "id": "916e328e-ad96-4d6c-a3e8-42b095bcb805",
                        "vapTypeId": 2,
                        "premium": 39,
                        "isActive": true,
                        "description": "From rocks, to glass to other road hazards… We’ll make sure your tyres and rims keep going round and round, no matter the damage",
                        "title": "Tyre and Rim",
                        "icon": "icons-vap-icons-tyre-and-rim-active",
                        "reasonRequired": true,
                        "premiumText": "39.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113460",
                        "vapTypeId": 1,
                        "premium": 19.5,
                        "isActive": true,
                        "description": "Offers you (and your car) a safe ride home, when driving yourself just isn't a good idea.",
                        "title": "Kings Cab",
                        "icon": "icons-vap-icons-kings-cab-active",
                        "reasonRequired": true,
                        "premiumText": "19.50",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113461",
                        "vapTypeId": 2,
                        "premium": 129,
                        "isActive": true,
                        "description": "This ensures that you'll have rental wheels for 30 days when your own are being repaired by 1 of our suppliers following a successful claim.",
                        "title": "Car Hire",
                        "icon": "icons-vap-icons-car-hire-active",
                        "reasonRequired": true,
                        "premiumText": "129.00",
                        "enabled": true
                    },
                    {
                        "id": "4c0cb071-42dd-4060-99ff-9f0214113467",
                        "vapTypeId": 3,
                        "premium": 116.29,
                        "isActive": true,
                        "description": "Covers the difference between what your car/motorbike is worth at the time of it being stolen or written off, and what you still owe on it.",
                        "title": "Credit Shortfall",
                        "icon": "icons-vap-icons-credit-shortfall-active",
                        "reasonRequired": true,
                        "premiumText": "116.29",
                        "enabled": true
                    }
                ],
                "accesoriesTotal": 8600,
                "policyCoverId": "54ced8d9-2135-41ad-a56c-adc100b3f7af"
            },
            "incidentType": {
                "id": 1,
                "description": "Collision"
            },
            "mbFront": [
                "Front fairing",
                "Front mudguard",
                "Windshield",
                "Headlight",
                "Front tyre",
                "Handlebars",
                "Front brake"
            ],
            "mbFrontLeft": [
                "Left shock",
                "Left indicator",
                "Left mirror",
                "Left fairing",
                "Clutch lever",
                "Left front footrest",
                "Gear lever",
                "Front left brake"
            ],
            "mbFrontRight": [
                "Right shock",
                "Right indicator",
                "Right mirror",
                "Right fairing",
                "Front brake lever",
                "Right front footrest",
                "Right front brake"
            ],
            "mbBackLeft": [
                "Left side engine",
                "Left rear footrest",
                "Left side exhaust",
                "Left side frame",
                "Left rear indicator",
                "Left rear suspension",
                "Left rear brake"
            ],
            "mbBackRight": [
                "Right side engine",
                "Right rear footrest",
                "Right side exhaust",
                "Right side frame",
                "Right rear indicator",
                "Right rear suspension",
                "Right rear brake"
            ],
            "mbBack": [
                "Carrier",
                "Exhaust",
                "Tail light",
                "Rear fairing",
                "Rear mudguard",
                "Rear shock",
                "Rear tyre",
                "Rear brake"
            ],
            "isInEdit": false,
            "incidentEventList": [
                {
                    "id": 12,
                    "description": "Collided with an animal"
                },
                {
                    "id": 676,
                    "description": "Collided with a pedestrian"
                },
                {
                    "id": 21,
                    "description": "Tyre burst and hit an object/vehicle"
                },
                {
                    "id": 13,
                    "description": "Collided with another vehicle"
                },
                {
                    "id": 11,
                    "description": "Pothole"
                },
                {
                    "id": 14,
                    "description": "Collided with an object (not another vehicle)"
                }
            ],
            "incidentEventType": {
                "id": 13,
                "description": "Collided with another vehicle"
            },
            "photoList": "",
            "incidentDate": "01-11-2022",
            "incidentTime": "13:00",
            "contactName": "Styling User",
            "contactNumber": "0820000000",
            "whereDescription": "Where",
            "addressLat": 37.774929,
            "whatDescription": "What",
            "extraDescription": "",
            "isDriveavle": true,
            "claimNumber": "",
            "lastCompletedStep": 10,
            "lastCompletedSubStep": 1,
            "IsIncidentDateClicked": false,
            "time": "13:00",
            "timeDisplay": "1:00 pm",
            "continueOnMobile": false,
            "showDisclaimer": false,
            "claimStatus": "",
            "hasSmashAndGrab": false,
            "glassDamage": false,
            "isRepaired": false,
            "glassSubmitDisabled": false,
            "hasBeenRepaired": false,
            "claimExcess": 0,
            "glassDrillDown": false,
            "selectedGlassDrilldown": "",
            "lastSelectedDamage": "Bonnet",
            "repairStepValid": false,
            "replacementExcessDescription": "",
            "repairExcessDescription": "",
            "isStationary": "no", "isDriverInjured" : false,
            "regularDriver": {
                "id": null,
                "claimCarId": null,
                "claimCarDriverTypeId": 1,
                "regularDriverId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "copyRegularDriver": true,
                "customerId": "243cfe91-b73f-4359-97c3-adc100b2ccf6",
                "firstName": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "idTypeId": 0,
                "contactId": null,
                "cellPhone": null,
                "homePhone": null,
                "workPhone": null,
                "addressId": null,
                "addressLine1": null,
                "addressLine2": null,
                "suburb": null,
                "city": null,
                "province": null,
                "postalCode": null,
                "relationshipId": null,
                "regularDriverDate": null,
                "licenseTypeId": null,
                "licenseCode": null,
                "licenseIssueDate": null,
                "licenseRestriction": null,
                "driverIdTypeId": null,
                "driverTypeId": 0,
                "countryId": null,
                "hasConsentRegularDriverItcCheck": false,
                "emailAddress": null,
                "vehicleMakeId": null,
                "vehicleModelId": null,
                "vehicleSeriesId": null,
                "vehicleYear": null,
                "regularDriverAddress": null,
                "claimMotorbikeDriverTypeId": 0,
                "claimWatercraftDriverTypeId": 0,
                "claimMotorbikeId": null,
                "motorbikeMakeId": null,
                "motorbikeModelId": null,
                "motorbikeSeriesId": null,
                "motorbikeYear": null,
                "hasSkipper": null,
                "claimWatercraftId": "00000000-0000-0000-0000-000000000000",
                "relationshipTypeDescription": null,
                "driverDateOfBirth": null,
                "driverVehicleRelationshipId": null
            },
            "driverDropdown": [
                {
                    "isPolicyHolder": true,
                    "isRegularDriver": true,
                    "name": "Styling",
                    "surname": "User",
                    "idNumber": "6909211760083",
                    "order": 1
                },
                {
                    "isPolicyHolder": false,
                    "isRegularDriver": false,
                    "name": "None of the listed drivers",
                    "surname": "",
                    "idNumber": "",
                    "order": 3
                }
            ],
            "policeReported": null,
            "policeReportNumber": "1234",
            "policeReportStation": "Menly",
            "blackListed": null,
            "blackListNumber": "",
            "claimDriver": {
                "isPolicyHolder": true,
                "isRegularDriver": true,
                "name": "Styling",
                "surname": "User",
                "idNumber": "6909211760083",
                "order": 1
            },
            "claimVehicleRegNo": "FRV516FS",
            "vehicleRegistrationConfirm": true,
            "isVehicleFinanced": "no",
            "selectedFinanceHouse": "",
            "claimVehicleTypes": [],
            "stolenLocations": [],
            "forcedEntryType": [],
            "contactPersonFullName": "Not given",
            "contactPersonNumber": "",
            "isResponsiblePersonMemberOfHousehold": null,
            "responsiblePersonFullName": "Not given",
            "responsiblePersonContactNumber": "",
            "deliveryLocationLongitude": 0,
            "deliveryLocationLatitude": 0,
            "selectedTypeOfCarId": null,
            "isVisibleSignsOfEntryIntoCar": null,
            "selectedEntryGainedId": null,
            "selectedWhereInTheCarId": null,
            "newDeviceName": "",
            "roadSurfaceTypes": [],
            "selectedRoadSurfaceTypes": "",
            "roadConditions": [],
            "selectedRoadConditions": "",
            "damageCauses": [
                {
                    "id": 45,
                    "description": "4 way stop",
                    "isActive": true
                },
                {
                    "id": 39,
                    "description": "Head on",
                    "isActive": true
                },
                {
                    "id": 40,
                    "description": "Lane change",
                    "isActive": true
                },
                {
                    "id": 37,
                    "description": "Rear ender",
                    "isActive": true
                },
                {
                    "id": 41,
                    "description": "Reversed",
                    "isActive": true
                },
                {
                    "id": 42,
                    "description": "Reversed simultaneously",
                    "isActive": true
                },
                {
                    "id": 43,
                    "description": "Right hand turn",
                    "isActive": true
                },
                {
                    "id": 44,
                    "description": "Robot controlled intersection",
                    "isActive": true
                },
                {
                    "id": 46,
                    "description": "Through road stop",
                    "isActive": true
                },
                {
                    "id": 47,
                    "description": "U-turn",
                    "isActive": true
                }
            ],
            "selectedDamageCauses": "",
            "insuranceCompanies": [],
            "selectedInsuranceCompany": "",
            "hasWitnesses": undefined,
            "hasThirdParties": undefined,
            "hasPassanger": undefined,
            "thirdPartyUnknownReason": "",
            "followUp": true,
            "followUpType": "multiple-collision",
            "partyErrorList": [],
            "stepLabel": 1
        }
        this.props.dispatchAction(setFnolReducerPayload(steps));
        this.props.dispatchAction(setFollowUpSteps(SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY));
        this.props.dispatchAction(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    public render() {
        return (
            <>
                <br />
                <br />
                <div id="appContainer" className="noProfile styling-project">
                    <div className="align-center text-center mt-60px">
                    </div>
                </div>

                <div id="appContainer" className="noProfile styling-project">
                    <div className="">
                        <div className="row new-page-main-row">
                            <div className="col-12 nopa">
                                <div className="row noma fnol-submitclaim-desktop-main-row">
                                    <div className="col d-none fnol-claim-progress-col"></div>
                                    <div className="col-12 col-lg">
                                        <span className="styling-foundation-page-header">
                                            SSP Styling Foundation
                                        </span>
                                        <div className="container-fluid new-page-margins fnol-capture-main-container">
                                            <div className="content-box-padding-20px-bottom-40px fnol-steps-content-area-desktop">
                                                <div className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding">
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_OTHER && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.otherThirdParties} />}
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_PEDESTRIAN && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.pedestrians} />}
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_PASSENGER && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.passengers} />}
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_WITNESS && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.witnesses} />}
                                                    <button className="btn btn-warning" onClick={(e) => this.handleAdd(THIRDPARTY_TYPE_PASSENGER)}>Add passanger</button>
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_OTHER && this.state.reRender && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.otherThirdParties} Submitted={this.state.submitted} ErrorList={this.state.errorList} />}
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_PEDESTRIAN && this.state.reRender && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.pedestrians} Submitted={this.state.submitted} />}
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_PASSENGER && this.state.reRender && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.passengers} Submitted={this.state.submitted} />}
                                                    {this.state.hasDriverType && this.state.hasDriverType !== undefined && this.props.claimSubmit.driverType == THIRDPARTY_TYPE_WITNESS && this.state.reRender && <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.witnesses} Submitted={this.state.submitted} />}
                                                    <button className="btn btn-warning" onClick={(e) => this.handleAdd(THIRDPARTY_TYPE_PASSENGER)}>Add passanger</button>
                                                    <button className="btn btn-info" onClick={(e) => this.handleAdd(THIRDPARTY_TYPE_PEDESTRIAN)}>Add pedestrian</button>
                                                    <button className="btn btn-dark" onClick={(e) => this.handleAdd(THIRDPARTY_TYPE_OTHER)}>Add other</button>
                                                    <button className="btn btn-danger" onClick={(e) => this.handleAdd(THIRDPARTY_TYPE_WITNESS)}>Add witness</button>
                                                    <button className="btn btn-danger" onClick={() => this.toggleSubmitted()}>Toggle Submit</button>
                                                    <button className="btn btn-danger" onClick={() => this.resubmit()}>Submit</button>
                                                    <button className="btn btn-danger" onClick={() => this.goFollowUp()}>Multi Vehicle!</button>
                                                    <button className="btn btn-danger" onClick={() => this.goFollowUpStationary()}>Multi Vehicle Stationary!</button>
                                                    <button className="btn btn-danger" onClick={() => this.goPothole()}>Pothole!</button>
                                                    <button className="btn btn-danger" onClick={() => this.goPedestrian()}>Pedestrian!</button>
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />

                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ThirdPartyPage)
